/* Copyright (c) 2017 Backpack Health LLC */

const actionNames = {

  requestAttachments: 'REQUEST_ATTACHMENTS',
  receiveAttachments: 'RECEIVE_ATTACHMENTS',
  requestAllFiles: 'REQUEST_ALL_FILES',
  receiveAllFiles: 'RECEIVE_ALL_FILES',
  requestAllNotes: 'REQUEST_ALL_NOTES',
  receiveAllNotes: 'RECEIVE_ALL_NOTES',
  receiveAllCards: 'RECEIVE_ALL_CARDS',

  requestAllHealthEntries: 'REQUEST_ALL_HEALTH_ENTRIES',
  receiveAllHealthEntries: 'RECEIVE_ALL_HEALTH_ENTRIES',

  requestPendingHealthEntries: 'REQUEST_PENDING_HEALTH_ENTRIES',
  receivePendingHealthEntries: 'RECEIVE_PENDING_HEALTH_ENTRIES',

  receiveHealthEntry: 'RECEIVE_HEALTH_ENTRY',
  requestHealthEntry: 'REQUEST_HEALTH_ENTRY',
  updateHealthEntry: 'UPDATE_HEALTH_ENTRY',
  deleteHealthEntry: 'DELETE_HEALTH_ENTRY',

  receiveHealthEntryValue: 'RECEIVE_HEALTH_ENTRY_VALUE',
  requestHealthEntryValue: 'REQUEST_HEALTH_ENTRY_VALUE',
  updateHealthEntryValue: 'UPDATE_HEALTH_ENTRY_VALUE',
  deleteHealthEntryValue: 'DELETE_HEALTH_ENTRY_VALUE',

  changedPreferredLanguage: 'CHANGED_PREFERRED_LANGUAGE',

  updatePendingHealthEntry: 'UPDATE_PENDING_HEALTH_ENTRY',
  clearPendingHealthEntry: 'CLEAR_PENDING_HEALTH_ENTRY',

  requestUser: 'REQUEST_USER',
  receiveMainUser: 'RECEIVE_MAIN_USER',

  receiveFile: 'RECEIVE_FILE',
  requestFile: 'REQUEST_FILE',
  updateFile: 'UPDATE_FILE',
  deleteFile: 'DELETE_FILE',

  receiveNote: 'RECEIVE_NOTE',
  requestNote: 'REQUEST_NOTE',
  updateNote: 'UPDATE_NOTE',
  deleteNote: 'DELETE_NOTE',

  clearSearchResults: 'CLEAR_SEARCH_RESULTS',

  updateMainUser: 'UPDATE_MAIN_USER',
  setLoadingProgress: 'UPDATE_LOADING_PERCENTAGE',
  setActiveProfile: 'SET_ACTIVE_PROFILE',
  setMainProfile: 'SET_MAIN_PROFILE',
  setSystemMessage: 'SET_SYSTEM_MESSAGES',
  setContentEntry: 'SET_CONTENT_ENTRY',
  setPendingEdit: 'SET_PENDING_EDIT',
  updatePendingEdit: 'UPDATE_PENDING_EDIT',
  clearPendingEdit: 'CLEAR_PENDING_EDIT',
  hasHeader: 'HAS_HEADER',
  hasLargeHeader: 'HAS_LARGE_HEADER',
  hasExtendedHeader: 'HAS_EXTENDED_HEADER',

  cpf_init: 'CPF_INIT',
  cpf_update: 'CPF_UPDATE',
  cpf_currentPassword: 'CPF_CURRENTPASSWORD',
  cpf_newPassword: 'CPF_NEWPASSWORD',
  cpf_mfaCode: 'CPF_MFACODE',
  cpf_passwordsSubmitted: 'CPF_PASSWORDSSUBMITTED',
  cpf_mfaCodeSubmitted: 'CPF_MFACODESUBMITTED',
  cpf_passwordSubmitSuccessful: 'CPF_PASSWORDSUBMITSUCCESSFUL',
  cpf_mfaCodeSubmittedSuccessful: 'CPF_MFACODESUBMITTEDSUCCESSFUL',
  cpf_reset: 'CPF_RESET',

  emfaf_reset: 'EMFAF_RESET',
  emfaf_init: 'EMFAF_init',
  emfaf_update: 'EMFAF_UPDATE',

  fuf_update: 'FUF_UPDATE',

  navigationGoTo: 'NAVIGATION_GO_TO',
  navigationSetHistory: 'NAVIGATION_SET_HISTORY',

  setNextProfileColor: 'SET_NEXT_PROFILE_COLOR',
  setCurrentColorTheme: 'SET_CURRENT_COLOR_THEME',

  receiveAllShareCards: 'RECEIVE_ALL_SHARE_CARDS',
  requestAllShareCards: 'REQUEST_ALL_SHARE_CARDS',
  receiveShareCardDefinitions: 'RECEIVE_SHARE_CARD_DEFINITIONS',
  requestShareCardDefinitions: 'REQUEST_SHARE_CARD_DEFINITIONS',
  addShareCard: 'ADD_SHARE_CARD',
  updateShareCard: 'UPDATE_SHARE_CARD',
  updateShareCardPasscode: 'UPDATE_SHARE_CARD_PASSCODE',
  deleteShareCard: 'DELETE_SHARE_CARD',

  setAvailableProfiles: 'UPDATE_AVAILABLE_PROFILES',
  addProfile: 'ADD_PROFILE',
  updateProfile: 'UPDATE_PROFILE',
  updateProfileTimestamp: 'UPDATE_PROFILE_TIMESTAMP',
  receivedProfileCollection: 'RECEIVED_PROFILE_COLLECTION',
  removeProfile: 'REMOVE_PROFILE',

  requestShareCardGroupContents: 'REQUEST_SHARE_CARD_GROUP_CONTENTS',
  receiveShareCardGroupContents: 'RECEIVE_SHARE_CARD_GROUP_CONTENTS',

};

export default actionNames;
